<template>
    <v-text-field 
        v-model="amount"
        @blur="emitAmountChange"
        :label="schema.label" 
        :hide-details="false" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder || ' '"
        outlined dense
        :suffix="abbreviation"
        prefix="$"
        append-icon="keyboard_arrow_down"
        @click:append="toggleFrequency"
    />
</template>

<script>



export default {

    data() {
        return { 
            amount: null,
            frequencyIndex: 0,
            frequencies: [
                {abbreviation: 'pm', name: 'monthly'},
                {abbreviation: 'pw', name: 'weekly'},
                {abbreviation: 'pf', name: 'fortnightly'},
                {abbreviation: 'pa', name: 'annually'},
            ]   
        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        schema: Object,
    },

    computed: {
        abbreviation: {
            get() {
                
                if(!this.value)
                    return this.schema.defaultAbbreviation || 'pm'
                else
                    return this.value.split(' ')[1]
            },
            set(newVal) {
                 if(!this.value)
                    return this.schema.defaultFrequency || 'pm'
                else
                    return newVal            
            }
        },
    },

    methods: {
        toggleFrequency() {
            let idx = this.frequencies.findIndex(f => f.abbreviation == this.abbreviation)
            
            idx = (idx == 3 ? 0 : idx+1)
            this.emitChanges(this.frequencies[idx].abbreviation)
        },

        emitAmountChange() {
            this.emitChanges(this.abbreviation)
        },

        emitChanges(abbreviation) {
            this.$emit('change', this.amount + ' ' + abbreviation)
        }

    },

    created() {

    },

    watch: {
        value: {
            immediate: true,
            handler: function(newVal) {
                console.log('watcher got: ', newVal)
                this.amount = (newVal ? newVal.split(' ')[0] : 0)
            }
        }
    }

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// PaymentControl.vue?5dbf6bd2